<template>
	<div class="container" :class="{ 'static': mode === 'static' }">
		<!--<alert-success
			v-if="mode !== 'static' && showAlert"
		/>-->

    <checkout-verify-coverage v-if="order" :open="!user"/>

		<div class="content-layout" :class="{ 'content-layout-4': mode === 'static'}">

			<tag-listing
				:selectedTagName="selectedTagName"
				:isScrollingDown="isScrollingDown"
				:mode="mode"
				:tags="tags"
				:extras="extrasEcommerce"
				@selectTag="selectTag"
			/>

			<div class="main">
				<div
					class="products" 
					v-if="$mq.isDesktop() || !$mq.isDesktop() && !billIsActive"
				>
					<div
						class="center"
					>
						<h2
							class="center"
							v-if="mode === 'static' && ($mq.isDesktop() || !$mq.isDesktop() && !showProducts)"
							v-html="`${showProducts ? showProducts : 'Non solo cene, ma anche prodotti per colazioni, pranzi e snack'}`"
						/>

						<div v-if="mode !== 'static'" class="pa-6">

						</div>
						<div
							class="content"
							v-if="mode === 'static'"
							v-html="selectedTagName
								? tagDescription
								: `Sfoglia il catalogo di prodotti di alta qualità per completare la tua spesa su Quomi. Aggiungili al tuo ordine una volta scelte le ricette della settimana.`"
						/>
					</div>

					<div
						class="title-section flex"
						v-if="!$mq.isDesktop()"
						:class="{'scrolled-down': isScrollingDown && mode === 'static' }"
						:style="$_appViewPosition_positionTop"
					>
						<h4
							@click="selectTag('all')"
							v-if="selectedTagName"
						>
							<i class="fas fa-angle-left" /> Indietro
						</h4>
						<h4
							@click="$router.push({name: 'flow-subscribed'})"
							v-else-if="mode !== 'static'"
						>
							<i class="fas fa-angle-left" /> Torna alle ricette
						</h4>
						<h4
							class="flex-right"
							v-if="selectedTagName"
							v-html="selectedTagName"
						/>
					</div>

					<div
						:class="{'view-content': showProducts && !$mq.isDesktop(), 'flex big-tags': !showProducts }"
					>

						<template v-if="!showProducts">
							<template v-if="tags">
								<div
									class="tag-section"
									v-for="(tag, index) in tags"
									:key="index"
								>		
									<div
										class="wrapper"
										@click="selectTag(tag.name)"
										:style="backgroundStyle(tag)"
									>
										<span
											v-html="tag.name"
										/>
									</div>
								</div>
							</template>

							<template v-if="!tags">
								<div
									class="tag-section"
									v-for="n in 4"
									:key="n"
								>		
									<div class="wrapper">
										<span />
									</div>
								</div>
							</template>
						</template>

						<div
							class="extra-listing"
							v-if="showProducts"
						>
							<div v-for="(extra, index) in extrasEcommerce" class="extra-container" :key="index">
								<extra-box
									:user="user"
									:item="extra"
									:order="order"
									:updating.sync="updating"
									@openModalExtra="$refs.modalExtra.open(extra)"
									:action="mode !== 'static'"
									:actionExecuted.sync="actionExecuted"
								/>
							</div>

							<div class="extra-container" :key="n" v-for="n in 4" v-if="!extrasEcommerce">
								<div class="placeholder" />
							</div>
						</div>
					</div>
				</div>

				<subscribed-bill ref="bill" v-if="mode !== 'static'" @update:billIsActive="billIsActive = $event" />
			</div>
		</div>

		<start-with-us
			v-if="mode === 'static'"
		/>
		
		<checkout-footer
			:ctaLabel="$t('components.checkout.confirm')"
			v-if="!$mq.isOffline() && mode !== 'static'"
			@confirm="confirm"
			:error="errorStore.message"
			:loading="loading"
			:allowMinCheck="true"
		/>

		<extra-modal
			ref="modalExtra"
			:user="user"
			:order='order'
			:updating.sync="updating"
			:action="mode !== 'static'"
		/>

		<div
			class="general-error"
			v-if="errorStore.message"
			v-html="errorStore.message"
		/>
	</div>
</template>

<script>
import { scrollToElementId } from '../../assets/js/main'

import { ExtraApi } from '../../api/ExtraApi'

import { Extras } from '../../core/Extras'
import { Order } from '../../core/Order'

import { subscriptionStore } from '../../store/subscriptionStore'
import { deliveryStore } from '../../store/deliveryStore'
import { errorStore } from '../../store/errorStore'
import { orderStore } from '../../store/orderStore'

import StartWithUs from '../Parts/StartWithUs'

import EcommerceFooter from './EcommerceFooter'
import SubscribedBill from '../Checkout/SubscribedBill'
import AlertSuccess from './AlertSuccess'
import TagListing from './TagListing'
import ExtraModal from './ExtraModal'
import ExtraBox from './ExtraBox'
import CheckoutFooter from '../Checkout/CheckoutFooter'
import { orderAction } from '../../mixins/orderAction'
import { container } from '../../services/container'
import CheckoutVerifyCoverage from './../Checkout/CheckoutVerifyCoverage'

import Usp from '../Usp'

import { Repository } from '../../services/Repository'
import { menuStore } from '../../store/menuStore' 

export default {
	mixins: [
		orderAction
	],

	props: {
		mode: {
			type: String,
			default: null
		}
	},

	components: {
		Usp,
		ExtraBox,
		ExtraModal,
		SubscribedBill,
    CheckoutVerifyCoverage,
		CheckoutFooter,
		AlertSuccess,
		TagListing,
		StartWithUs
	},

	data () {
		return {
			tags: null,
			extrasEcommerce: null,

			updating: false,

			selectedTagName: null,

			isConfirmed: true,

			billIsActive: false,

			loading: false,

			isScrollingDown: false,

			actionExecuted: false,

			orderStore: orderStore.state,
			errorStore: errorStore.state,
			deliveryStore: deliveryStore.state,
			subscriptionStore: subscriptionStore.state,
			menuStore: menuStore.state
		}
	},

	watch: {
		'$route' () {
			this.onRouteChange()
		},

		'billIsActive' () {
			if (!this.$mq.isDesktop()) {
				var query = this.billIsActive ? { bill: true } : null
				this.changeRoute({ action: 'push', query: query })
			}
		},

		updating () {
			this.isConfirmed = false
		}
	},

	computed: {
		showProducts() {
			return this.selectedTagName;
		},
		disabled () {
			// return this.orderStore.order.prices.gross < 19.90
			return false;
		},
		delivery () {
            var sub = this.subscriptionStore.subscription
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },

		tagDescription () {
			if (!this.tags) return
			if (!this.selectedTagName) return
			var tag = this.tags.find(tag => tag.name && tag.name === this.selectedTagName)
			return tag && tag.description
		},

		showAlert () {
			if (this.$mq.isDesktop()) return true
			if (this.billIsActive) return false
			if (this.selectedTagName) return false
			return true
		},

		shipmentDayEq3 () {
			return this.delivery
				&& this.delivery.shipment_day === 3
		}
	},

	methods: {
		onRouteChange () {
			var tag = this.$route.query.tag
			this.selectedTagName = tag === 'all' ? null : tag

		},
		backgroundStyle (tag) {
			if (!tag || !tag.images) return
			if (!this.$mq.isDesktop()) {
				return {
					backgroundImage: 'url(' + (tag.images.small ? tag.images.small : tag.images.big) + ')'
				}
			} else {
				return {
					backgroundImage: 'url(' + tag.images.big + ')'
				}
			}
		},

		loadTags () {
			var em = new ExtraApi()
			em.tags().then(response => {
				this.tags = response.body.data.resources

				// remove 'bread' tag
				//this.removeTag({ id: 24 })
			})
		},

		removeTag (params) {
			if (this.mode === 'static') return
			if (this.shipmentDayEq3) {
				if (!params || !params.id) return
				var index = this.tags.findIndex(r => r.id && r.id === params.id)
				if (index >= 0) {
	 				this.tags.splice(index, 1)
	 			}
			}
		},

		removeExtra (params) {
			if (this.mode === 'static') return
			if (this.shipmentDayEq3) {
				if (!params || !params.id) return
				var index = this.extrasEcommerce.findIndex(r => r.id && r.id === params.id)
				if (index >= 0) {
	 				this.extrasEcommerce.splice(index, 1)
	 			}
			}
		},

		loadExtras (params) {

			this.extrasEcommerce = null

			if (!params) return

			let query = [];

			if (params.tag) {
				query.push(`shopTags.name ct '${params.tag}'`)
			}


			if (query.length === 0) {
				return;
			}

			var em = new ExtraApi()
			em.all({
				params: {
					show: 100,
					page: 1,
					sort_direction: 'asc',
					query: query.join(' and ')
				}
			})

			.then(response => {
				this.extrasEcommerce = new Extras(response.body.data.resources)
				// remove extra with id 2050 (== 'classic breakfast')
				// this.removeExtra({ id: 2050 }) 
			})
		},

		selectTag (tag) {
			// scroll to top
			scrollToElementId()
			this.loadExtras({ tag: tag })

			this.changeRoute({ action: 'push', query: { tag: tag } })		
		},

		confirm () {

			return this.goToNextStep();

			if (this.loading) {
				return;
			}

			this.loading = true




			this.$_orderAction_updateCurrentRecipes(0).then(i => {
				this.goToNextStep();
			}).catch(response => {
				errorStore.formatMessage(response)
				this.loading = false
			})
		},

		transitionOnScroll () {
			var currentPosition = 0

			this.$nextTick(function () {
				window.addEventListener('scroll', () => {
					var isScrollingDown = () => window.scrollY > currentPosition && window.scrollY > 10
					this.isScrollingDown = isScrollingDown()
					currentPosition = window.scrollY
				})
			})
		},

		goToNextStep()
		{
			this.$router.push({ name: this.user.isNew() ? 'flow-new' : 'thank-you-ecommerce' })
		},

		changeRoute(vars) {
			if (!vars) return

			var params = {
				name: this.$route.name,
				params: this.$route.params,
				query: vars.query
			}

			if (vars.action === 'replace') {
				this.$router.replace(params)
			} else {
				this.$router.push(params)	
			}
		},

		loadCurrentDelivery () {
			if (this.user && this.user.subscription) subscriptionStore.state.subscription = this.user.subscription
			if (!this.subscriptionStore.subscription) return Promise.resolve()
			return deliveryStore.getDelivery({ 
	        	target_type: 'order', 
	        	target_id: this.subscriptionStore.subscription.id
	    	})
		}
	},

	mounted () {

		this.confirmCallback = (e) => {
			if (this.$route.name === 'ecommerce') {
				this.goToNextStep();
			}
		}
		this.onChangeDelivery = (e) => {
			this.loadExtras();
		}

		window.addEventListener('billing-cart-confirm', this.confirmCallback);
		window.removeEventListener('delivery-change', this.onChangeDelivery);

		let rep = new Repository();
      menuStore.loadCurrentMenu().then(i => {
      console.log('ya')
    }).then(i => {
      if (menuStore.redirectHandler()) {
        throw "No menu"
      }
      console.log('ya')
      return rep.retrieveOrCreateOrder()
    }).then(i => {
			
			this.changeRoute({ action: 'replace', query: { tag: this.$route.query.tag}})
			this.onRouteChange()
			if (this.$route.query.tag !== 'all') this.selectTag(this.$route.query.tag)
			this.transitionOnScroll()

			return this.loadCurrentDelivery()

		}).then(response => {
			this.loadTags()
		})
			
	},

	destroyed () {
		window.removeEventListener('billing-cart-confirm', this.confirmCallback);
		window.removeEventListener('delivery-change', this.onChangeDelivery);
	}

}

</script>

<style scoped>
.container {
	padding-bottom: 100px;
}

.container.static {
	padding-bottom: 0px;
}

.scrolled-down {
	transform: translateY(-55px);
}

.content {
	max-width: 1024px;
	margin: 0 auto;
	padding: 0 10px;
}

.main {
	transition: all .4s ease;
	flex-basis: calc(100%);
	padding: 20px 20px 20px 20px;
	position: relative;
	display: flex;
}

* >>> h2 {
	padding: 10px;
}

* >>> h4 {
	font-size: 14px;
	margin-bottom: 5px;
	font-weight: 600;
}

h3 {
	font-weight: bold;
}

* >>> .view-content {
	padding: 80px 20px 40px 20px;
}

* >>> .usp-content.text-uppercase {
	font-weight: bold;
}

.btn {
	margin: 0;
	border-radius: 4px;
}

.alert + .content-layout {
	padding-top: 50px;
}

.content-layout {
	display: flex;
	justify-content: center;
}

.products {
	width: 100%;
	position: relative;
	padding-top: 10px;
}

.big-tags {
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	padding: 10px 0 40px 0;
	cursor: pointer;
}

.tag-section {
	flex-basis: calc(100% / 4 - 30px);
	margin: 10px 10px;
}

.content-layout-4 .tag-section {
	flex-basis: calc(100% / 4 - 30px);
}

.tag-section .wrapper {
	overflow: hidden;
	border-radius: 6px;
	background-color: #ededed;
	margin: 0;
	box-sizing: border-box;
	background-size: cover;
	width: 100%;
	padding: 50% 0;
	height: 100%;
	position: relative;
	cursor: pointer;
}

.tag-section .wrapper span {
	font-weight: bold;
	text-align: center;
	width: 90%;
	position: absolute;
	top: 50%;
	right: 50%;
	transform: translate(50%, -50%);
	color: #575A5C;
	font-size: 21px;
	text-shadow: white 1px 1px 3px;
}


* >>> .title-section {
	width: 100%;
	border-bottom: 1px solid #ededed;
	padding: 21px 8px 13px 8px;
	position: fixed;
	background-color: white;
	z-index: 2;
	top: 50px;
	transition: all 0.5s ease;

}

* >>> .title-section h4 {
	font-size: 18px;
}

.extra-listing {
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	align-items: stretch;
	margin: 0 -10px;
}

.recipe-image {
	min-width: 50px;
	max-width: 50px;
	overflow: hidden;
	vertical-align: middle;
	margin-right: 10px;
}

.general-error {
	bottom: 35px;
}

.extra-container {
	flex-basis: calc(100% / 4 - 10px);
	margin: 0 5px 20px 5px;
}

.content-layout-4 .extra-container {
	flex-basis: calc(100% / 4 - 10px);
}

.extra-container .placeholder {
	height: 300px;
	background: #ededed;
}

@media (max-width: 1024px) {
	.tag-section {
		flex-basis: calc(100% / 2 - 30px);
		margin: 10px 10px;
	}

	.content-layout-4 .tag-section {
		flex-basis: calc(100% / 3 - 30px);
	}


	.main {
		padding: 0;
	}

	.main h2 {
		margin: 10px 5px 10px 5px;;
	}

	.alert + .content-layout {
		padding-top: 80px;
	}

	.extra-container {
		flex-basis: calc(100% / 2 - 10px);
		margin: 0 5px 20px 5px;
	}

	.content-layout-4 .extra-container {
		flex-basis: calc(100% / 4 - 10px);
	}
}

@media (max-width: 800px) {
	.content-layout-4 .tag-section {
		flex-basis: calc(100% / 2 - 30px);
	}

	.content-layout-4 .extra-container {
		flex-basis: calc(100% / 2 - 10px);
	}
}

@media (max-width: 768px) {

	.extra-container {
		flex-basis: calc(100% / 2 - 10px);
	}

}
</style>
